import { ConfigHeader } from "../../types/config";
import {
  facebookIcon,
  forumIcon,
  rssIcon,
  telegramIcon,
  tiktokIcon,
  twitterIcon,
  youtubeIcon,
} from "../icons/socialIcon";

export const configHeader: ConfigHeader = {
  megaMenu: {
    newsletter: {
      text: "Sign up for our weekly newsletters for the best fashion, beauty, travel and exclusive events",
      url: "/newsletter-signup",
      buttonText: "Sign Up",
    },
    closeButton: {
      type: "icon",
      placement: "right",
    },
  },
  socialMedia: {
    target: "_blank",
    icons: [
      {
        icon: twitterIcon,
        name: "Twitter",
        href: "https://twitter.com/hardwarezone",
      },
      {
        icon: facebookIcon,
        name: "Facebook",
        href: "https://www.facebook.com/hardwarezone",
      },
      {
        icon: youtubeIcon,
        name: "Youtube",
        href: "https://www.youtube.com/user/hardwarezonecom",
      },
      {
        icon: rssIcon,
        name: "RSS Feeds",
        href: "https://www.hardwarezone.com.sg/feeds",
      },
      {
        icon: tiktokIcon,
        name: "Tiktok",
        href: "https://www.tiktok.com/@hwztech",
      },
      {
        icon: telegramIcon,
        name: "Telegram",
        href: "https://t.me/HardwareZoneSG",
      },
      {
        icon: forumIcon,
        name: "Forum",
        href: "https://forums.hardwarezone.com.sg/",
      },
    ],
  },
};
